import styled from 'styled-components';

import { convertPxToRem } from '@proprioo/salatim';

export const FilterButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${convertPxToRem(8)};
`;
